import { render, staticRenderFns } from "./SearchGridActions.vue?vue&type=template&id=764779d9&scoped=true&"
import script from "./SearchGridActions.vue?vue&type=script&setup=true&lang=js&"
export * from "./SearchGridActions.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764779d9",
  null
  
)

export default component.exports